




















import { Component, Prop, Vue } from 'vue-property-decorator';

import InputComponent from '@/components/FormElements/InputComponent.vue';
import LabelComponent from '@/components/FormElements/LabelComponent.vue';
import SelectComponent from '@/components/FormElements/SelectComponent.vue';

@Component({
  components: {
    SelectComponent,
    InputComponent,
    LabelComponent,
  },
})
export default class MultipleChoiceResponse extends Vue {
  @Prop() public readonly value!: string | null;
  @Prop(Array) public readonly choices!: string[];

  get selectedChoice() {
    return this.value;
  }

  set selectedChoice(newValue) {
    this.$emit('input', newValue);
  }
}
